var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMfaLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "mfa_lock_svg__svg-safari-fix",
  viewBox: "0 0 159 132",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DEF7F3",
  d: "M6.487 81.995C-9.9 68.619 8.314 61.333 21.97 57.935 62.438 47.863 52.728 51.428 89.5 63.5c45.964 15.089-16.567 51.935-44.545 58.052s-37.97-8.564-31.475-17.536 13.491-5.301-6.993-22.021"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DEF7F3",
  d: "M154.512 60.957c15.537-22.155-19.206-19.101-46.081-8.635C96.73 62.63 73.244 86.102 72.908 97.537c-.421 14.294 94.175 8.685 79.965-8.838-10.329-12.736-8.767-12.905 1.639-27.742"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BFBFFF",
  d: "M36 59c0-7.18 5.82-13 13-13h60c7.18 0 13 5.82 13 13v52c0 10.493-8.507 19-19 19H49c-7.18 0-13-5.82-13-13z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#A0A0FF",
  d: "m79 6.5.424-4.982-.212-.018H79zM107.5 45a5 5 0 0 0-10 0zM59 45V31.5H49V45zm0-13.5c0-4.384.915-9.433 3.679-13.26C65.234 14.7 69.869 11.5 79 11.5v-10c-11.87 0-19.734 4.383-24.429 10.886C50.085 18.6 49 26.05 49 31.5zm19.576-20.018c3.198.272 8.13 1.606 12.127 4.58C94.503 18.888 97.5 23.184 97.5 30h10c0-10.384-4.836-17.505-10.828-21.962-5.794-4.31-12.612-6.125-17.248-6.52zM97.5 30v15.265h10V45h-10v.265h10V30z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F0E5B",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M49 45V31.5C49 21.667 54.9 2 78.5 2M106 45H49c-10.5 0-14 4.6-14 21v45M92 129.5h10.5c10.5 0 18-3.7 18-20.5V82.5"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#5555E7",
  fillRule: "evenodd",
  d: "M83.974 83.69a9 9 0 1 0-10.954 2.385l-3.143 13.232A3 3 0 0 0 72.796 103H85.52a3 3 0 0 0 2.885-3.825l-4.42-15.45z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F0E5B",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "m72.5 86.5-3.244 15.292a1 1 0 0 0 .978 1.208h13.532a1 1 0 0 0 .978-1.208l-3.131-14.761c-.07-.331.032-.672.261-.921 2.951-3.205 6.53-10.123-.374-15.11"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 96,
  r: 22,
  fill: "#ADEFE4"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F0E5B",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M124.5 74.227c-3.167-.5-10.7-.5-15.5 3.5"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#08AC92",
  fillRule: "evenodd",
  d: "M122.003 107.667c6.443 0 11.666-5.224 11.666-11.667s-5.223-11.667-11.666-11.667S110.336 89.557 110.336 96s5.223 11.667 11.667 11.667m4.474-14.525a1.167 1.167 0 0 0-1.948-1.284l-3.75 5.687-1.451-1.451a1.167 1.167 0 0 0-1.65 1.65l2.463 2.463a1.168 1.168 0 0 0 1.799-.183z",
  clipRule: "evenodd"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F0E5B",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M107 111.388c5.085 4.213 18.082 10.253 29.39.705s7.53-23.374 4.228-29.093"
})));
export default SvgMfaLock;